import { PractitionerListComponent } from './practitioner-list/practitioner-list.component';
import { PractitionerDetailsComponent } from './practitioner-details/practitioner-details.component';
import { PractitionerRegistrationComponent } from './practitioner-registration/practitioner-registration.component';
import { OrganizationManagementComponent } from './organization-management/organization-management.component';
import { Routes } from '@angular/router';
import { PatientsComponent } from './patients/patients.component';
import { patientsResolver } from './patients.resolver';
import { PatientsRecordComponent } from './patients-record/patients-record.component';
import { patientsRecordResolver } from './patients-record/patients-record.resolver';
import { PatientObservationComponent } from './patient-observation/patient-observation.component';
import { patObsResolver } from './patient-observation/pat-obs.resolver';
import { PatientWrapperComponent } from './patient-wrapper/patient-wrapper.component';
import { PatientConditionComponent } from './patient-condition/patient-condition.component';
import { patCondResolver } from './patient-condition/pat-cond.resolver';
import { PatientDocumentsComponent } from './patient-documents/patient-documents.component';
import { NotFoundComponentComponent } from './not-found-component/not-found-component.component';
import { MedicationComponent } from './medication/medication.component';
import { medicationResolver } from './medication/medication.resolver';
import { AppWrapperComponent } from './app-wrapper/app-wrapper.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { appointmentResolver } from './appointment.resolver';
import { encounterResolver } from './encounter/encounter.resolver';
import { EncounterComponent } from './encounter/encounter.component';
import { ZoomMeetingComponent } from './zoom-meeting/zoom-meeting.component';
import { DashboardsWrapperComponent } from './dashboards-wrapper/dashboards-wrapper.component';
import { LoginComponent } from './login/login.component';
import { appAuthGuard } from './shared/auth/app-auth.guard';
import { roleGuard } from './shared/auth/role.guard';

import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

import { LabRequestsComponent } from './lab-requests/lab-requests.component';
import { labRequestsResolver } from './lab-requests/lab-requests.resolver';
import { DummyMedicationRequestDetailsComponent } from './dummy-medication-request-details/dummy-medication-request-details.component';
import { MedicineRequestsComponent } from './medicine-requests/medicine-requests.component';
import { medReqResResolver } from './medicine-requests/med-req-res.resolver';
import { PatientRegistrationComponent } from './patient-registration/patient-registration.component';
import { PatientHospitalSelectionComponent } from './patient-hospital-selection/patient-hospital-selection.component';
import { patRegResolver } from './patient-reg/pat-reg.resolver';
import { PatientRegComponent } from './patient-reg/patient-reg.component';
import { MakeAppointmentsComponent } from './make-appointments/make-appointments.component';
import { SpecimenDetailsComponent } from './specimen/specimen-details/specimen-details.component';
import { HospitalDetailsComponent } from './hospital-details/hospital-details.component';
import { HospitalRegistrationComponent } from './hospital-registration/hospital-registration.component';
import { ServicesComponent } from './services/services.component';
import { ProfileComponent } from './profile/profile.component';
import { OrdersComponent } from './orders/orders.component';
import { AdmissionComponent } from './admission/admission.component';
import { TestingTasksComponent } from './testing-tasks/testing-tasks.component';
import { AddVitalsComponent } from './patient-observation/add-vitals/add-vitals.component';
import { TasksTableComponent } from './tasks/tasks-table/tasks-table.component';
import { AdmissionAnalyticsComponent } from './admission-analytics/admission-analytics.component';
import { PatientAdmissionWrapperComponent } from './patient-admission-wrapper/patient-admission-wrapper.component';
import { MedicationComponent2 } from './medication2/medication2.component';
import { AddMedicationComponent } from './medication2/add-medication/add-medication.component';
import { AllergyComponent } from './allergy/allergy.component';
import { PatientSidedetailsComponent } from './patient-sidedetails/patient-sidedetails.component';
import { TestingComponent } from './testing/testing.component';
import { MedicationDosageValidatorComponent } from './testing/medication-dosage-validator/medication-dosage-validator.component';
import { ImmunizationComponent } from './immunization/immunization.component';
import { LabreportComponent } from './labreport/labreport.component';
import { AddReportComponent } from './labreport/add-report/add-report.component';
import { EncounterV2Component } from './encounter-v2/encounter-v2.component';
import { SpecimenComponent } from './specimen/specimen_old.component';
import { LabSupplyComponent } from './lab-supply/lab-supply.component';
import { SpecimensComponent } from './specimens/specimens.component';
import { CreateScheduleComponent } from './create-schedule/create-schedule.component';
import { DetailsCardzComponent } from './details-cardz/details-cardz.component';
import { DutyRosterComponent } from './duty-roster/duty-roster.component';
import { CardzDetailsCheckComponent } from './cardz-details-check/cardz-details-check.component';
import { AichatComponent } from './aichat/aichat.component';
import { BookingsFormComponent } from './bookings-form/bookings-form.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { CalendarComponent } from './calendar/calendar.component';
import { DocumentComponent } from './document/document.component';
import { AddObservationComponent } from './patient-observation/add-observation/add-observation.component';
import { CheckSheetComponent } from './check-sheet/check-sheet.component';
import { EncounterCheckComponent } from './encounter-check/encounter-check.component';
import { LaunchComponent } from './launch/launch.component';
import { AuthcallackComponent } from './authcallack/authcallack.component'
import { AzureUploadDemoComponent } from './upload-ui/azure-upload-demo.component';
import { PatientRegistrationCenterComponent } from './patient-registration-center/patient-registration-center.component';
import { patientRegistrationCenterResolver } from './patient-registration-center/patient-registration-center.resolver';
import { PatientRegistrationApprovedComponent } from './patient-registration-center/patient-registration-approved.component';
import { PatientRegistrationDeceasedComponent } from './patient-registration-center/patient-registration-deceased.component';
import { PatientRegistrationImportComponent } from './patient-registration-import/patient-registration-import.component';
import { appWrapperDataResolver } from './app-wrapper/app-wrapper-data.resolver';
import { AdmissionLocationComponent } from './admission-location/admission-location.component';
import { AddAdmissionLocationComponent } from './admission-location/add-admission-location.component';
import { MedicationDispenseComponent } from './medication-dispense/medication-dispense.component';
import { AdmittedPatientsComponent } from './admitted-patients/admitted-patients.component';
import { AddServiceRequestCodesComponent } from './add-service-request-codes/add-service-request-codes.component';
import { ServiceRequestCodesListComponent } from './add-service-request-codes/service-request-codes-list.component';
import { ChargesComponent } from './charges/charges.component';
import { AddChargesComponent } from './charges/add-charges/add-charges.component';
import { SupplyStockComponent } from './supply-stock/supply-stock.component';
import { HospitalSelectionLoginComponent } from './hospital-selection-login/hospital-selection-login.component';
import { HomeComponent } from './home/home.component';
import { FulfillTaskComponent } from './tasks/fulfill-task/fulfill-task.component';
import { ServiceRequestsComponent } from './service-requests/service-requests.component';
import { DiagnosticReportComponent } from './diagnostic-report/diagnostic-report.component';
import { PatientEncountersComponent } from './patient-encounters/patient-encounters.component';
import { ServiceRequestWrapperComponent } from './service-request-wrapper/service-request-wrapper.component';
import { AddServiceDetailsPageComponent } from './add-service-details/add-service-details-page.component';
import { HealthcareServicesV2Component } from './healthcare-services-v2/healthcare-services-v2.component';
import { ObservationReferenceRangesComponent } from './observation-reference-ranges/observation-reference-ranges.component';
//import { ServiceDetailsComponent } from './service-details/service-details.component';
import { SchedulesComponent } from './schedules/schedules.component';
import { PharmacyDashboardComponent } from './pharmacy-dashboard/pharmacy-dashboard.component';
import { ReceptionistDashboardComponent } from './receptionist-dashboard/receptionist-dashboard.component';

import { ServiceDetailsComponent } from './service-details/service-details.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

import { SuperadminListComponent } from './super-admin-management/superadmin-list.component';
import { SuperadminCreateComponent } from './super-admin-management/superadmin-create.component';

import { EventsComponent } from './events/events.component'
import { NotificationsPageComponent } from './notifications-page/notifications-page.component';
import { MessagingInboxPageComponent } from './messaging/messaging-inbox-page.component';
import { MessagingThreadPageComponent } from './messaging/messaging-thread-page.component';

import { ConsultationRequestsComponent } from './consultation-requests/consultation-requests.component';
import { ReferralsComponent } from './referral-requests/referral-requests.component';
import { CompanySettingsComponent } from './company-settings/company-settings.component';
import { RequestDocumentViewerPageComponent } from './referral-document-viewer/request-document-viewer-page.component';
import { defaultPasswordGuard } from './shared/auth/default-password.guard';
import { AboutComponent } from './aboutUs/about.component';
import { ContactComponent } from './contactUs/contact.component';
import { EventRegistrationPageComponent } from './events/event-registration-page.component';
import { AdminScheduleCalendarComponent } from './schedules/admin-schedule-calendar/admin-schedule-calendar.component';
import { TriageComponent } from './triage/triage.component';

export const routes: Routes = [
    {
    path: '',
    component: HomeComponent,
    data: {
      title: 'Home',
      breadCrumbTitle: 'Home',
      breadCrumbIcon: 'home'
    }
  },
  {
    path: 'about',
    component: AboutComponent,
    data: {
      title: 'About Us',
      breadCrumbTitle: 'About Us',
      breadCrumbIcon: 'info'
    }
  },
  {
    path: 'contact',
    component: ContactComponent,
    data: {
      title: 'Contact Us',
      breadCrumbTitle: 'Contact Us',
      breadCrumbIcon: 'mail'
    }
  },
    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'events',
        component: EventsComponent
    },
    {
    path: 'events/:eventId/register',
    component: EventRegistrationPageComponent
    },
    {
        path: 'hospital-selection',
        component: HospitalSelectionLoginComponent
    },
    {
        path: 'register-hospital',
        component: HospitalRegistrationComponent // You'll need to create this
    },
    {
        path: 'practitioners/:id',
        component: PractitionerDetailsComponent,
        data: {
            title: 'Practitioner Details',
            breadCrumbTitle: 'Practitioner Details',
            breadCrumbIcon: 'badge',
            roles: ['hospitaladmin', 'healthcareadmin']
        }
    },

    {
        path: 'unauthorized',
        component: UnauthorizedComponent,
        data: {
            title: 'Access Denied',
            breadCrumbTitle: 'Unauthorized',
            breadCrumbIcon: 'block'
        }
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent
    },
    {
        path: "testing",
        component: TestingComponent,
        children: [
            {
                path: "encounter",
                component: EncounterCheckComponent
            },
            {
                path: "add-obs",
                component: AddObservationComponent
            },
            {
                path: "check-sheet",
                component: CheckSheetComponent
            },
            //admission'
            {
                path: "document",
                component: DocumentComponent
            },
            {
                path: "calendar",
                component: CalendarComponent,
            },
            {
                path: "dosage-validator",
                component: MedicationDosageValidatorComponent,
                data: {
                    title: 'Medication Dosage Validator',
                    breadCrumbTitle: 'Dosage Validator',
                    breadCrumbIcon: 'vaccines'
                }
            },
            {

                path: "ai-chat",
                component: AichatComponent
            },
            {
                path: "details",
                component: CardzDetailsCheckComponent

            },
            {
                path: "book-try",
                component: BookingsFormComponent
            },


            {
                path: "schedule",
                component: CreateScheduleComponent
            },
            {
                path: "add-medicine",
                component: AddMedicationComponent
            },
            {
                path: "ec-bills",
                component: EncounterV2Component

            }, {
                path: "lab-report",
                component: LabreportComponent

            },
            {
                path: "add-report",
                component: AddReportComponent

            },
            {
                path: "medicine",
                component: MedicationComponent2,

            },
            {
                path: "admission",
                component: AdmissionComponent,
                data: { title: 'Admission' }
                // resolve: { admission: admissionResolver }
            },
            {
                path: "admission-analytics",
                component: AdmissionAnalyticsComponent,

            },
            {
                path: "vitals",
                component: AddVitalsComponent,
            },
            {
                path: "tasks",
                component: TestingTasksComponent,


            },
            {

                path: "patientSide",
                component: PatientSidedetailsComponent
            },
            {
                path: "allergy",
                component: AllergyComponent,
            },
            {
                path: "task-list",
                component: TasksTableComponent,

            },
            {
                path: "tests-requests",
                component: LabRequestsComponent,
                resolve: { labRequests: labRequestsResolver }


            },
            {
                path: "claims",
                component: OrdersComponent,


            },
            {
                path: "invoice",
                component: InvoiceComponent
            },
            {
                path: "invoice/:patientId",
                component: InvoiceComponent
            },

            {
                path: "medicine-requests",
                component: MedicineRequestsComponent,
                // resolve: { medReqRes: medReqResResolver }


            },
            {
                path: "specimen-details",
                component: SpecimenDetailsComponent,
                data: {
                    title: "Specimen Details", breadCrumbTitle: "Specimen Details",
                    breadCrumbIcon: "biotech"
                },
            },
            {
                path: "org",
                component: HospitalDetailsComponent,
                data: {
                    title: "Hospital Details", breadCrumbTitle: "Hospital Details",
                    breadCrumbIcon: "local_hospital"
                },
            },

            //services,
            {
                path: "org-services",
                component: ServicesComponent,
                data: {
                    title: "Available Services", breadCrumbTitle: "Available Services",
                    breadCrumbIcon: "work"
                }
            }
        ]
    },
    {
        path: "app",
        component: AppWrapperComponent,
        resolve: { orgWide: appWrapperDataResolver },
        canActivate: [appAuthGuard, roleGuard, defaultPasswordGuard],
        canActivateChild: [appAuthGuard, roleGuard],
        data: { title: 'Dashboard' },
        children: [
            //services-creation
            {
                path: "invoice/:patientId",
                component: InvoiceComponent
            },
            
            {
                path: 'services-details',
                component: ServiceDetailsComponent,
                data: {
                    title: 'Service Details',
                    breadCrumbTitle: 'Service Details',
                    breadCrumbIcon: 'build',
                    roles: ['hospitaladmin', 'alliedhealthprofessional'],
                }
            },
            
            {
                path: 'add-service-details',
                component: AddServiceDetailsPageComponent,
                data: {
                    title: 'Add Service Details',
                    breadCrumbTitle: 'Add Service Details',
                    breadCrumbIcon: 'add',
                    roles: ['hospitaladmin', 'alliedhealthprofessional'],
                }
            },
            {
                path: 'healthcare-services',
                component: HealthcareServicesV2Component,
                data: {
                    title: 'Healthcare Services',
                    breadCrumbTitle: 'Healthcare Services',
                    breadCrumbIcon: 'medical_services',
                    roles: ['hospitaladmin']
                }
            },
            //service-reuest
            {
                path: 'service-requests',
                // loadComponent: () =>
                //     import('./service-requests/service-requests.component').then(m => m.ServiceRequestsComponent),
                component: ServiceRequestWrapperComponent,
                data: {
                    title: 'Service Requests',
                    breadCrumbTitle: 'Service Requests',
                    breadCrumbIcon: 'assignment',
                },
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'lab-tests'
                    },
                    //lab
                    {
                        path: 'lab-tests',
                        component: LabRequestsComponent,
                        resolve: { labRequests: labRequestsResolver }

                    },
                    {
                        path: ':type',
                        component: ServiceRequestsComponent,
                        data: {
                            title: 'Service Requests',
                            breadCrumbTitle: 'Service Requests',
                            breadCrumbIcon: 'assignment',
                        }
                    }

                ]

            },
            //medicine-stock
            {
                path: 'practitioners',
                component: PractitionerListComponent,
                data: {
                    title: 'Pending Practitioners',
                    breadCrumbTitle: 'Practitioners',
                    breadCrumbIcon: 'badge',

                }
            },
            {
                path: "practitioner-register",
                component: PractitionerRegistrationComponent
            },
            {
                path: 'organizations',
                component: OrganizationManagementComponent,
                data: {
                    title: "Organizations Management", breadCrumbTitle: "Organizations Management",
                    breadCrumbIcon: "add_business"
                },
            },
            {
  path: 'global-remote-doctors',
  loadComponent: () =>
    import('./global-remote-doctors/global-remote-doctors.component')
      .then(m => m.GlobalRemoteDoctorsComponent),
  data: {
    title: 'Global Remote Doctors',
    breadCrumbTitle: 'Remote Doctors',
    breadCrumbIcon: 'medical_services',
    roles: ['superadmin']
  }
},

            {
                path: 'Users',
                component: SuperadminListComponent,
                data: {
                    title: "Users Management", breadCrumbTitle: "Users Management",
                    breadCrumbIcon: "people"
                },
            },

            {
                path: 'superadmin/create',
                component: SuperadminCreateComponent
            },
            {
                path: "org-reg",
                component: HospitalRegistrationComponent,
                data: {
                    title: "Hospital Registration", breadCrumbTitle: "Hospital Registration",
                    breadCrumbIcon: "add_business"
                },
            },
            {
                path: 'notifications',
                component: NotificationsPageComponent,
                data: {
                    title: 'Notifications',
                    breadCrumbTitle: 'Notifications',
                    breadCrumbIcon: 'notifications'
                }
            },
            {
                path: 'messaging',
                component: MessagingInboxPageComponent,
                data: {
                    title: 'Messaging Inbox',
                    breadCrumbTitle: 'Messaging',
                    breadCrumbIcon: 'forum'
                }
            },
            {
                path: 'messaging/thread',
                component: MessagingThreadPageComponent,
                data: {
                    title: 'Messaging Thread',
                    breadCrumbTitle: 'Thread',
                    breadCrumbIcon: 'chat'
                }
            },
            {
                path: "document",
                component: DocumentComponent
            },
            {
                path: "calendar",
                component: CalendarComponent,
            },
            {
                path: "schedule",
                component: CreateScheduleComponent

            },
            {
                path: "schedules",
                 data: { title: 'Schedules' },
                children: [
                    {
                        path: "create",
                        component: CreateScheduleComponent

                    },
                    {
                        path: "admin-calendar/:practitionerId",
                        component: AdminScheduleCalendarComponent
                    },

                    {
                        path: 'schedules-list',
                        component: SchedulesComponent,
                        canActivate: [appAuthGuard],
                        data: {
                            title: 'Schedules',
                            breadCrumbTitle: 'Schedules',
                            breadCrumbIcon: 'calendar_today',
                            roles: [
                                'remotedoctor',
                                'hospitaladmin',
                                'doctor',
                                'primaryhealthcareprovider',
                                'healthcareassistant',
                                'nursemidwife',
                                'alliedhealthprofessional'
                            ]
                        }
                    },
                    //default path
                    {
                        path: "",
                        redirectTo: 'schedules-list',
                        pathMatch: "full"



                    }

                ],
            },
            {
                path: "tasks",
                component: TasksTableComponent,
    data: { title: 'Tasks' }
            },
            {
                path: "duty-roster",
                component: DutyRosterComponent,
                canActivate: [appAuthGuard, roleGuard],
                data: { 
                    title: 'Duty Roster',
                    breadCrumbTitle: 'Duty Roster',
                    breadCrumbIcon: 'calendar_month',
                    roles: ['healthcareadmin', 'hospitaladmin', 'remotedoctor', 'doctor'] 
                }
            },
            {
                path: "specimens",
                component: SpecimensComponent,
            },
            {
                path: "lab-supplies",
                component: LabSupplyComponent,
                data: { roles: ['hospitaladmin', 'alliedhealthprofessional', 'lab', 'labtechnician', 'pharmacist'] }
            },
            {
                path: "medicine-stock",
                component: MedicationComponent2
            },
            {
                path: "admission",
                component: AdmissionComponent,
                // resolve: { admission: admissionResolver }
            },
            {
                path: "admission-location",
                component: AdmissionLocationComponent
            },
            {
                path: "admission-location/add",
                component: AddAdmissionLocationComponent
            },
            {
                path: "service-codes",
                component: ServiceRequestCodesListComponent,
                data: {
                    title: "Service Request Codes",
                    breadCrumbTitle: "Service Codes",
                    breadCrumbIcon: "science",
                    roles: ['hospitaladmin', 'alliedhealthprofessional', 'lab', 'labtechnician']
                }
            },
            {
                path: "service-codes/add",
                component: AddServiceRequestCodesComponent,
                data: {
                    title: "Add Service Code",
                    breadCrumbTitle: "Add Service Code",
                    breadCrumbIcon: "science",
                    roles: ['hospitaladmin', 'alliedhealthprofessional', 'lab', 'labtechnician']
                }
            },
            {
                path: "claims",
                component: OrdersComponent,


            },
            {
                path: "patient-bills/:encounterId/:patientId",
                component: EncounterV2Component,


            },

            {
                path: "invoice",
                component: InvoiceComponent
            },
            {
                path: "profile",
                component: ProfileComponent,
                data: { title: 'Profile' }

            },
            {
                path: "org-services",
                component: ServicesComponent,
                data: {
                    title: "Available Services", breadCrumbTitle: "Available Services",
                    breadCrumbIcon: "work"
                }
            },

            {
                path: "org",
                component: HospitalDetailsComponent,
                data: {
                    title: "Hospital Details", breadCrumbTitle: "Hospital Details",
                    breadCrumbIcon: "local_hospital"
                }

            },
            {
                path: "company-settings",
                component: CompanySettingsComponent,
                data: {
                    title: "Company Settings",
                    breadCrumbTitle: "Company Settings",
                    breadCrumbIcon: "settings",
                    roles: ['hospitaladmin', 'superadmin']
                }

            },
            {
                path: "dashboard",
                component: DashboardsWrapperComponent,
                data: { title: 'Dashboard' },

            },
            {
                path: 'terminology-migration',
                loadComponent: () => import('./admin-dashboard/terminology-migration/terminology-migration.component').then(m => m.TerminologyMigrationComponent),
                data: {
                    title: 'Terminology Sync',
                    breadCrumbTitle: 'Terminology Sync',
                    breadCrumbIcon: 'sync',
                    roles: ['superadmin']
                }
            },
            {
                path: 'pharmacy-dashboard',
                component: PharmacyDashboardComponent,
                data: {title: 'Pharmacy Dashboard', roles: ['pharmacist', 'pharmacy', 'hospitaladmin'] }
            },
            {
                path: 'receptionist-dashboard',
                component: ReceptionistDashboardComponent,
                data: {  title: 'Healthcare Admin Dashboard', roles: ['healthcareadmin', 'cashier', 'hospitaladmin'] }
            },
            {
                path: 'profit-margins',
                loadComponent: () => import('./profit-margins/profit-margins.component').then(m => m.ProfitMarginsComponent),
                data: {
                    title: 'Profit Margins',
                    breadCrumbTitle: 'Profit Margins',
                    breadCrumbIcon: 'trending_up',
                    roles: ['cashier']
                }
            },
            {
                path: "patient-registration",
                component: PatientRegistrationCenterComponent,
                resolve: { patientCenter: patientRegistrationCenterResolver },
                data: {
                    title: "Patient Registration", breadCrumbTitle: "Patient Registration",
                    breadCrumbIcon: "person_add"
                },
                children: [
                    { path: '', redirectTo: 'pending', pathMatch: 'full' },
                    { path: 'pending', component: PatientRegComponent },
                    { path: 'approved', component: PatientRegComponent },
                    { path: 'deceased', component: PatientRegComponent },
                    { path: 'archived', component: PatientRegComponent },
                    { path: 'import', component: PatientRegistrationImportComponent },
                ]
            },
            { path: "patient-registration-data", redirectTo: "patient-registration", pathMatch: 'full' },
            {
                path: "medicine-requests",
                component: MedicineRequestsComponent,
                // resolve: {
                //     medReqRes: medReqResResolver
                // }
                // ,
    data: { title: 'Medicine Requests' }

            },

            {
                path: "appointments",
                component: AppointmentComponent,
                resolve: { appointment: appointmentResolver }
                ,
    data: { title: 'Appointments' }

            },
            {
                path: "appointments/add",
                component: MakeAppointmentsComponent
            },
            {
                path: "book-appointment",
                component: BookingsFormComponent,
                data: {
                    title: "Book Appointment",
                    breadCrumbTitle: "Book Appointment",
                    breadCrumbIcon: "event_available",
                    defaultBookingType: "Telemedicine"
                }
            },
{
    path: "remote-doctor/my-hospitals",
    loadComponent: () =>
        import('./remote-doctor/remote-doctor-dashboard/remote-doctor-dashboard.component')
            .then(m => m.RemoteDoctorDashboardComponent),
    data: {
        title: 'My Hospitals',
        breadCrumbTitle: 'My Hospitals',
        breadCrumbIcon: 'local_hospital',
        roles: ['remotedoctor']
    }
},{
    path: 'hospital-remote-doctors',
    loadComponent: () =>
        import('./remote-doctor/hospital-remote-doctors/hospital-remote-doctors.component')
            .then(m => m.HospitalRemoteDoctorsComponent),
    data: {
        title: 'Remote Doctors',
        breadCrumbTitle: 'Remote Doctors',
        breadCrumbIcon: 'medical_information',
        roles: ['hospitaladmin']
    }
},
            {
                path: "tests-requests",
                component: LabRequestsComponent,
                resolve: { labRequests: labRequestsResolver }
            },
            {
                path: "observation-reference-ranges",
                component: ObservationReferenceRangesComponent,
                data: {
                    title: "Observation Reference Ranges",
                    breadCrumbTitle: "Reference Ranges",
                    breadCrumbIcon: "analytics",
                    roles: ['lab', 'labtechnician', 'alliedhealthprofessional']
                }
            },
            
            {
                path: "medication-dispense",
                component: MedicationDispenseComponent,
                data: {
                    title: "Medication Dispenses",
                    breadCrumbTitle: "Medication Dispenses",
                    breadCrumbIcon: "medical_services"
                }
            },
            {
                path: "diagnostic-reports",
                component: DiagnosticReportComponent,
                data: {
                    title: "Diagnostic Reports",
                    breadCrumbTitle: "Diagnostic Reports",
                    breadCrumbIcon: "science"
                }
            },
            {
                path: 'triage',
                component: TriageComponent,
                data: {
                    title: 'Triage',
                    breadCrumbTitle: 'Triage',
                    breadCrumbIcon: 'health_and_safety',
                }
            },
            {
                path: "patient-encounters",
                component: PatientEncountersComponent,
                data: {
                    title: "Patient Encounters",
                    breadCrumbTitle: "Encounters",
                    breadCrumbIcon: "local_hospital"
                }
            },
            {
                path: "charges",
                component: ChargesComponent,
                data: {
                    title: "Charges",
                    breadCrumbTitle: "Charges",
                    breadCrumbIcon: "payments"
                }
            },
            {
                path: "charges/add",
                component: AddChargesComponent,
                data: {
                    title: "Add Charge",
                    breadCrumbTitle: "Add Charge",
                    breadCrumbIcon: "add_circle"
                }
            },
            {
                path: "supply-stock",
                component: SupplyStockComponent,
                data: {
                    title: "Supply Stock",
                    breadCrumbTitle: "Supply Stock",
                    breadCrumbIcon: "inventory_2",
                    roles: ['hospitaladmin', 'lab']
                }
            },

            {
                component: PatientsComponent,
                path: "patients",
                resolve: { patientsRegistrationData: patientsResolver },
                data: { title: 'Patients' }
            },
            {
                component: AdmittedPatientsComponent,
                path: "admitted-patients",
                resolve: { patientsRegistrationData: patientsResolver }
                ,
                data: { title: 'Admitted Patients' }

            },
            {
                path: "consultation-requests",
                component: ConsultationRequestsComponent,
                data: {
                    title: "Consultation Requests",
                    breadCrumbTitle: "Consultations",
                    breadCrumbIcon: "assignment_ind"
                }
            },
            {
                path: "referral-requests",
                component: ReferralsComponent,
                data: {
                    title: "Referral Requests",
                    breadCrumbTitle: "Referrals",
                    breadCrumbIcon: "forward_to_inbox"
                }
            },
            {
                path: "request-documents/:serviceRequestId",
                component: RequestDocumentViewerPageComponent,
                data: {
                    title: "Shared Clinical Document",
                    breadCrumbTitle: "Request Document",
                    breadCrumbIcon: "description"
                }
            },
            {
                path: "zoom-meetings",
                component: ZoomMeetingComponent,
                data: {
                    title: "Zoom Meeting",
                    breadCrumbTitle: "Zoom Meeting",
                    breadCrumbIcon: "videocam"
                }
            },
            {
                path: "zoom-meetings/:appointmentId",
                component: ZoomMeetingComponent,
                data: {
                    title: "Zoom Meeting",
                    breadCrumbTitle: "Zoom Meeting",
                    breadCrumbIcon: "videocam"
                }
            },
            {
                path: "admitted-patients/:id",
                component: PatientAdmissionWrapperComponent,
                children: [
                    {
                        path: "tasks",
                        component: TasksTableComponent,
                    },
                    {
                        path: "analytics",
                        component: AdmissionAnalyticsComponent
                    },
                    {
                        path: "",
                        redirectTo: "tasks",
                        pathMatch: 'full'
                    }
                ],
                // resolve: { admission: admissionResolver }

            },
            {

                path: "patients/:id",
                component: PatientWrapperComponent,
                resolve: { patientData: patientsRecordResolver },
                 data: { title: 'Patient Record' },
                children: [
                    //service-requests
                    {
                        path: 'service-requests',
                        // loadComponent: () =>
                        //     import('./service-requests/service-requests.component').then(m => m.ServiceRequestsComponent),
                        component: ServiceRequestWrapperComponent,
                        data: {
                            title: 'Service Requests',
                            breadCrumbTitle: 'Service Requests',
                            breadCrumbIcon: 'assignment',
                        },
                        children: [
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'lab-tests'
                            },
                            //lab
                            {
                                path: 'lab-tests',
                                component: LabRequestsComponent,
                                resolve: { labRequests: labRequestsResolver }

                            },
                            {
                                path: ':type',
                                component: ServiceRequestsComponent,
                                data: {
                                    title: 'Service Requests',
                                    breadCrumbTitle: 'Service Requests',
                                    breadCrumbIcon: 'assignment',
                                }
                            }

                        ]

                    },
                    //allergies
                    {
                        path: "tests-requests",
                        component: LabRequestsComponent,
                        resolve: { labRequests: labRequestsResolver }


                    },

                    {
                        path: "allergies",
                        component: AllergyComponent

                    },
                    //immunizations
                    {
                        path: "immunizations",
                        component: ImmunizationComponent
                        ,
            data: { title: 'Immunizations' }

                    },


                    {
                        path: "patients-reg",
                        component: PatientRegistrationComponent,
                        resolve: { patReg: patRegResolver }

                    },
                    {
                        path: "encounters",
                        resolve: { patientEncounter: encounterResolver },
                        component: EncounterComponent,
                        data: {
                            title: "Patient Encounter"
                        }

                    },
                    {
                        path: "observations",
                        resolve: { patientObservations: patObsResolver },
                        component: PatientObservationComponent,
                        data: { title: "Patient Observations" }
                    },
                    {
                        path: "diagnosis",

                        component: PatientConditionComponent,
                        resolve: { patCond: patCondResolver },
                        data: { title: "Patient Diagnosis" }

                    },
                    {
                        path: "tests-requests",
                        component: LabRequestsComponent,
                        resolve: { labRequests: labRequestsResolver }


                    },
                    // {
                    //     path: "medications",

                    //     component: MedicationComponent,
                    //     resolve: { patMed: medicationResolver },
                    //     data: { title: "Patient Medications" }

                    // },
                    {
                        path: "medications",

                        component: MedicineRequestsComponent,
                        // resolve: {
                        //     medReqRes: medReqResResolver
                        // },

                        data: { title: "Patient Medications" }

                    },
                    {
                        path: "diagnostic-reports",
                        component: DiagnosticReportComponent,
                        data: {
                            title: "Diagnostic Reports",
                            breadCrumbTitle: "Diagnostic Reports",
                            breadCrumbIcon: "science"
                        }
                    },
                    {
                        path: "patient-encounters",
                        component: PatientEncountersComponent,
                        data: {
                            title: "Encounters",
                            breadCrumbTitle: "Encounters",
                            breadCrumbIcon: "local_hospital"
                        }
                    },
                    {
                        path: "patient-documents",
                        component: PatientDocumentsComponent,
                        data: {
                            title: "Patient Documents",
                            breadCrumbTitle: "Documents",
                            breadCrumbIcon: "folder"
                        }
                    },
                    {
                        path: "zoom-meeting",
                        component: ZoomMeetingComponent,
                        data: {
                            title: "Zoom Meeting",
                            breadCrumbTitle: "Zoom Meeting",
                            breadCrumbIcon: "videocam"
                        }
                    },
                    {
                        path: "zoom-meeting/:appointmentId",
                        component: ZoomMeetingComponent,
                        data: {
                            title: "Zoom Meeting",
                            breadCrumbTitle: "Zoom Meeting",
                            breadCrumbIcon: "videocam"
                        }
                    },
                     {
                        path: "zoom-meeting",
                        component: ZoomMeetingComponent,
                        data: {
                            title: "Zoom Meeting",
                            breadCrumbTitle: "Zoom Meeting",
                            breadCrumbIcon: "videocam"
                        }
                    },
                    {
                        path: "request-documents/:serviceRequestId",
                        component: RequestDocumentViewerPageComponent,
                        data: {
                            title: "Shared Clinical Document",
                            breadCrumbTitle: "Request Document",
                            breadCrumbIcon: "description"
                        }
                    },


                    {
                        path: "summary",

                        component: PatientsRecordComponent,
                        resolve: { patientData: patientsRecordResolver },
                        data: { title: "Patient Summary" }

                    },


                    {
                        path: "",
                        redirectTo: "summary",
                        pathMatch: 'full'

                    },
                    {
                        path: "**",
                        component: NotFoundComponentComponent
                    }

                ]

            },
            {
                path: "",
                redirectTo: "dashboard",
                pathMatch: 'full'
            }
        ]

    },

    {
        path: "DummyMedicationRequest",
        component: DummyMedicationRequestDetailsComponent,

    },

    {
        path: "login",
        component: LoginComponent,
       data: { title: "Login" }
    },

    {
        path: "auth/callback",
        component: AuthcallackComponent,
        data: { title: "Login Redirect" }
    },

    {
        path: "launch",
        component: LaunchComponent,
       data: { title: "Launch" }
    },

    {
        path: "patient-hospital-selection",
        component: PatientHospitalSelectionComponent
    },
    {
        path: "upload-demo",
        component: AzureUploadDemoComponent
    },
    {
        path: 'testing',
        children: [
            {
                path: "encounter",
                component: EncounterCheckComponent
            },
            {
                path: "add-obs",
                component: AddObservationComponent
            },
            {
                path: "check-sheet",
                component: CheckSheetComponent
            },
            //admission'
            {
                path: "document",
                component: DocumentComponent
            },
            {
                path: "calendar",
                component: CalendarComponent,
            },
            {

                path: "ai-chat",
                component: AichatComponent
            },
            {
                path: "details",
                component: CardzDetailsCheckComponent

            },
            {
                path: "book-try",
                component: BookingsFormComponent
            },


            {
                path: "schedule",
                component: CreateScheduleComponent
            },
            {
                path: "add-medicine",
                component: AddMedicationComponent
            },
            {
                path: "ec-bills",
                component: EncounterV2Component

            }, {
                path: "lab-report",
                component: LabreportComponent

            },
            {
                path: "add-report",
                component: AddReportComponent

            },
            {
                path: "medicine",
                component: MedicationComponent2,

            },
            {
                path: "admission",
                component: AdmissionComponent,
                // resolve: { admission: admissionResolver }
            },
            {
                path: "admission-analytics",
                component: AdmissionAnalyticsComponent,

            },
            {
                path: "vitals",
                component: AddVitalsComponent,
            },
            {
                path: "tasks",
                component: TestingTasksComponent,


            },
            {

                path: "patientSide",
                component: PatientSidedetailsComponent
            },
            {
                path: "allergy",
                component: AllergyComponent,
            },
            {
                path: "task-list",
                component: TasksTableComponent,

            },
            {
                path: "tests-requests",
                component: LabRequestsComponent,
                resolve: { labRequests: labRequestsResolver }


            },
            {
                path: "claims",
                component: OrdersComponent,


            },
            {
                path: "invoice",
                component: InvoiceComponent,
                data: { title: 'Invoice' }
            },
            {
                path: "medicine-requests",
                component: MedicineRequestsComponent,
                // resolve: { medReqRes: medReqResResolver }


            },
            {
                path: "specimen-details",
                component: SpecimenDetailsComponent,
                data: {
                    title: "Specimen Details", breadCrumbTitle: "Specimen Details",
                    breadCrumbIcon: "biotech"
                },
            },
            {
                path: "org",
                component: HospitalDetailsComponent,
                data: {
                    title: "Hospital Details", breadCrumbTitle: "Hospital Details",
                    breadCrumbIcon: "local_hospital"
                },
            },

            //services,
            {
                path: "org-services",
                component: ServicesComponent,
                data: {
                    title: "Available Services", breadCrumbTitle: "Available Services",
                    breadCrumbIcon: "work"
                }
            },
            {
                path: 'fulfill-task',
                component: FulfillTaskComponent,
                // loadComponent: () => import('./tasks/fulfill-task/fulfill-task.component').then(m => m.FulfillTaskComponent),
                data: {
                    title: 'Test Fulfill Task',
                    breadCrumbTitle: 'Fulfill Task Test',
                    breadCrumbIcon: 'task_alt'
                }
            },
            {
                path: 'add-medication',
                component: AddMedicationComponent,
                // loadComponent: () => import('./medication2/add-medication/add-medication.component').then(m => m.AddMedicationComponent),
                data: {
                    title: 'Test Add Medication',
                    breadCrumbTitle: 'Add Medication Test',
                    breadCrumbIcon: 'medication'
                }
            }
        ]
    },
    {
        path: "DummyMedicationRequest",
        component: DummyMedicationRequestDetailsComponent,

    },

    {
        path: "login",
        component: LoginComponent,
        data: { title: "Login" }
    },

    {
        path: "auth/callback",
        component: AuthcallackComponent,
      data: { title: "Login Redirect" }
    },

    {
        path: "launch",
        component: LaunchComponent,
        data: { title: "Launch" }
    },


    {
        path: "register",
        component: PatientRegistrationComponent
    },
    {
    path: 'documentation',
    loadChildren: () =>
        import('./documentation/documentation.routes').then(m => m.documentationRoutes),
    canActivate: [appAuthGuard],
    data: {
        title: 'Documentation',
        breadCrumbTitle: 'Documentation',
        breadCrumbIcon: 'menu_book'
    }
},
     {
    path: 'remote-doctor/register',
    loadComponent: () =>
        import('./remote-doctor/remote-doctor-registration/remote-doctor-registration.component')
            .then(m => m.RemoteDoctorRegistrationComponent),
    data: { title: 'Remote Doctor Registration' }
},
    {
        path: "upload-demo",
        component: AzureUploadDemoComponent
    },

    { path: "zoom-meetings", redirectTo: "app/zoom-meetings", pathMatch: 'full' },
    { path: "zoom-meetings/:appointmentId", redirectTo: "app/zoom-meetings/:appointmentId", pathMatch: 'full' },
    { path: "", redirectTo: "launch", pathMatch: 'full' },
    { path: "**", component: NotFoundComponentComponent },
    //upload-demo
    // {
    //     path: 'app/service-requests',
    //     loadComponent: () =>
    //         import('./service-requests/service-requests.component').then(m => m.ServiceRequestsComponent),
    //     data: {
    //         title: 'Service Requests',
    //         breadCrumbTitle: 'Service Requests',
    //         breadCrumbIcon: 'assignment',
    //         roles: ['doctor', 'nurse', 'lab', 'pharmacy', 'consultant', 'hospitaladmin'] // view for practitioners; add button still doctor-only
    //     }
    // },
];
